import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';
import LazyImage from '../../CustomLibraries/LazyImage';
import { MdOutlineArrowRightAlt } from '../../icons';
import queryString from 'query-string';
import './css/automatedCTA.scss';
import { getLocalStorage } from '../../../common/common';
import { content_cta_suscribe_service_v1_static_image } from '../../../common/assets.common';

const CtaSubscribeServiceV1 = ({ data, onClickCallback, isSubscribed }) => {
  const { pathname, search } = useLocation();

  const { id } = queryString.parse(search);
  const servicesArr = () =>
    getLocalStorage('services', false) ? getLocalStorage('services', false) : {};
  const serviceName = (id) => {
    let services = servicesArr();
    if (services && services?.length > 0) {
      return services?.find((_serv) => _serv.id == id)?.name ?? '';
    } else {
      return '';
    }
  };
  return (
    <div className="w-100 subsServiceCTABox position-relative overflow-hidden shadow p-5 rounded-3">
      <div className="ctaCardBoxIn">
        <div className="d-flex flex-column align-items-center ctaCardTop">
          <div className="ctaCardIcon mb-5">
            <img
              src={content_cta_suscribe_service_v1_static_image}
              alt=""
              className="object-fit-cover w-100 h-100 float-start"
            />
          </div>
          <h4 className="fs-3 text-black fw-medium text-center mb-3">
            We are elated to serve you with awesome content
          </h4>
          <h6 className="fs-4 fw-medium text-dark mb-5">
            Don’t want to miss any {serviceName(data?.service)}?
          </h6>
          <button
            className="w-100 btn btn-secondary fs-4 fw-medium rounded-3 text-center ctaLink d-flex align-items-center justify-content-center gap-2"
            disabled={isSubscribed}
            onClick={() =>
              onClickCallback(
                data?.id,
                data?.cta_type_id,
                data?.entity_id,
                data?.entity_value,
                3,
                pathname,
                id
              )
            }
          >
            {isSubscribed ? 'Subscribed' : 'Subscribe Now'}{' '}
            <MdOutlineArrowRightAlt customClass={'fs-4 text-white'} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default memo(CtaSubscribeServiceV1);
